'use client'
import useFlightTimingFilterManager from '@/src/hooks/srp/flightTimingFilterManager'
import { FlightTimingsFilter } from '../flightTimings/FlightTimingsFilter'

const ArrivalTimingsFilterWrapper = () => {
    const { timeSlots, handleSelectToggle, handleReset, shouldShowReset, title } = useFlightTimingFilterManager(
        0,
        'arrival'
    ) //as long as solution view , pass leg number not going to affect , it will auto decide in search-hooks

    return (
        <FlightTimingsFilter
            flightTimings={timeSlots}
            onTimeSlotSelect={handleSelectToggle}
            onReset={handleReset}
            shouldShowReset={shouldShowReset}
            title={title}
        />
    )
}

export { ArrivalTimingsFilterWrapper as ArrivalTimingsFilter }

export default ArrivalTimingsFilterWrapper
